import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common';
import { AppSettings } from 'app/infrastructure/settings';

@Injectable()
export class ProductService {
    constructor(private http: AuthHttp) { }

    getOwnerConfig(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "Product/GetOwnerConfig", options)
            .map((response: Response) => response.json());
    }

    getProductCode(productCode: string, ownerCode: string) {
      let params: URLSearchParams = new URLSearchParams();
      params.set('productCode', productCode);
      params.set('ownerCode', ownerCode);

      let options: RequestOptions = new RequestOptions({ search: params });
      return this.http.get(AppSettings.apiEndpoint + 'Product/GetProductCode', options)
          .map((response: Response) => response.json());
    }

    getProductDescription(productDescription: string, ownerCode: string) {
      let params: URLSearchParams = new URLSearchParams();
      params.set('productDescription', productDescription);
      params.set('ownerCode', ownerCode);

      let options: RequestOptions = new RequestOptions({ search: params });
      return this.http.get(AppSettings.apiEndpoint + 'Product/GetProductDescription', options)
          .map((response: Response) => response.json());
    }

    getProductsWithNameByOwner(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "Product/GetProductsWithNameByOwner", options)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/wm/product.service.ts